import React, { useState } from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { Box } from 'transfix-ui/core'
import { ICarrierApplicationEntityTypes } from 'types/graphqlTypes'
import { EditIcon } from 'transfix-icons'
import { IconButton, brandColors } from 'transfix-ui'
import { ValueField } from '../../ValueField'
import { CompanyInformationEditModal } from './CompanyInformationEditModal'
import { TCompanyInformationEditModalSchema } from './CompanyInformationEditModal/CompanyInformationEditModalSchema'
import { ENTITY_TYPE } from './constants'
import { useEntityTypeMutation } from './graphql/EntityTypeMutation'

interface IEntityTypeField {
  entityType: Maybe<ICarrierApplicationEntityTypes>
  carrierApplicationId: string | undefined
  refetch: () => void
}

const EntityTypeField = ({ carrierApplicationId, entityType, refetch }: IEntityTypeField) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)
  const [entityTypeMutation] = useEntityTypeMutation()

  const openHandler = () => {
    setIsEditModalOpen(true)
  }

  const closeHandler = () => {
    setIsEditModalOpen(false)
  }

  const submitHandler = (data: TCompanyInformationEditModalSchema) => {
    entityTypeMutation({
      variables: {
        input: {
          entityType: data.entityType as ICarrierApplicationEntityTypes,
          carrierApplicationId,
        },
      },
    }).then(() => {
      refetch()
      closeHandler()
    })
  }

  return (
    <div>
      {entityType && (
        <Box
          borderTop={`1px solid ${brandColors.coolGray2}`}
          mt={2}
          pt={2}
          display='flex'
          alignItems='center'
          justifyContent='space-between'>
          <ValueField title='Entity Type' value={ENTITY_TYPE[entityType]} />
          <IconButton Icon={EditIcon} color='secondary' onClick={openHandler} size='large' />
        </Box>
      )}
      <CompanyInformationEditModal
        onClose={closeHandler}
        onConfirm={submitHandler}
        onCancel={closeHandler}
        open={isEditModalOpen}
      />
    </div>
  )
}

export default EntityTypeField
